import React from "react";
var __jsx = React.createElement;
import LocationInfo from './LocationInfo';
function LocationInfoAdapter(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  return __jsx(LocationInfo, {
    locationInfoData: entry,
    yextContactInfo: data.yextContactInformationData
  });
}
export default LocationInfoAdapter;